import { PropsWithChildren } from 'react';
import clsx from 'clsx';

interface ITabsProps {
  tabs: Array<{ index: string; title?: string; icon?: JSX.Element; tooltip?: string }>;
  selected: string;
  tabStyle?: number;
  onSwitch: (e: string) => void;
  additionalClasses?: string;
}
export const Tabs = ({ tabs, selected, additionalClasses, tabStyle = 0, onSwitch }: ITabsProps) => {
  return (
    <div className={clsx('w-full px-8 border-b border-line', additionalClasses)}>
      <nav className="flex justify-start flex-wrap" aria-label="Tabs">
        {tabs.map((el, idx) => (
          <div key={`tab-${idx}`}>
            <div
              data-tooltip-id="tab-tooltip"
              data-tooltip-content={el.index !== selected && el?.title ? el.title : ''}
              className={clsx(
                'whitespace-nowrap mx-1 px-3 py-[6px] font-medium text-[13px] rounded-3xl flex justify-center items-center',
                {
                  ' text-black hover:bg-highlightGray hover:border-gray-300 cursor-pointer': el.index !== selected
                },
                { 'border font-medium border-tabBorder bg-lightGray leading-5': !tabStyle && el.index !== selected },
                { 'border font-medium text-white bg-black leading-5': !tabStyle && el.index === selected },
                {
                  'border font-semibold border-[#ddd] text-[#555555] bg-white px-[10px] py-[5px] flex-wrap':
                    tabStyle === 1 && el.index !== selected
                },
                {
                  'border font-semibold border-[#000] text-[#555555] bg-[#f2f2f2] px-[10px] py-[5px] flex-wrap':
                    tabStyle === 1 && el.index === selected
                },
                {
                  'leading-full mx-0 font-normal border-[#ddd] text-[#555555] h-[26px] bg-white hover:bg-iconColor hover:bg-opacity-[0.4] px-[10px] pt-[1px] my-[5px] pb-[2px] flex-wrap rounded-md':
                    tabStyle === 2 && el.index !== selected
                },
                {
                  'leading-full mx-0 h-full font-semibold border-secondaryTabBorder text-[#555555] bg-white px-[10px] pt-[1px] pb-[2px] flex-wrap border-b-[3px] rounded-none':
                    tabStyle === 2 && el.index === selected
                }
              )}
              onClick={() => onSwitch(el.index)}
            >
              {el.icon}
              {el.title}
            </div>
          </div>
        ))}
      </nav>
    </div>
  );
};

interface TabPanelProps {
  index: string;
  active: boolean;
}

export const TabPanel = (props: PropsWithChildren<TabPanelProps>) => {
  const { children, active, index, ...rest } = props;

  return (
    <div role="tabpanel" id={`tabpanel-${index}`} {...rest} className={active ? 'h-full' : 'hidden h-full'}>
      {children}
    </div>
  );
};
